import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const BigBgTopSquareIcon = ({
  width = "156",
  height = "43",
  style,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} style={style}>
      <svg
        width="156"
        height="43"
        viewBox="0 0 156 43"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M10.647 42.4779H94.0249C104.053 42.4779 113.417 37.4836 118.978 29.169L153.287 -22.1227C157.842 -28.9313 152.913 -38.0454 144.702 -37.9998L59.2791 -37.5254C50.5583 -37.477 42.4164 -33.1675 37.4936 -25.9943L1.87354 25.9081C-2.95063 32.9375 2.10087 42.4779 10.647 42.4779Z"
          fill="#DEDEDE"
        />
      </svg>
    </IconWrapper>
  );
};
